import React, { useState, useEffect } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../utils/axiosconfig';
import { useAuth } from '../../context/authcontext';
import './login.css';

const LoginComponent = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { login } = useAuth();

  const validateForm = () => {
    let formErrors = {};

    if (!email.trim()) {
      formErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      formErrors.email = 'Email is invalid';
    }

    if (!password) {
      formErrors.password = 'Password is required';
    } else if (password.length < 6) {
      formErrors.password = 'Password must be at least 6 characters long';
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
      formErrors.password = 'Password must contain at least one uppercase letter, one lowercase letter, and one number';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  useEffect(() => {
    validateForm();
  }, [email, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await api.post('/auth/signIn', { email, password });
      login(response.data.access_token);
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred during login');
    } finally {
    }
  };

  return (
    <section className="section-account parallax bg-11">
      <div className="awe-overlay"></div>
      <div className="container">
        <div className="login-register">
          <div className="text text-center">
            <h2>LOGIN ACCOUNT</h2>
            <div className="login-box">
              <form onSubmit={handleSubmit} className="account_form">
                <div className="field-form">
                  <input
                    type="email"
                    className={`field-text ${errors.email ? 'is-invalid' : ''}`}
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>
                <div className="field-form">
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`field-text ${errors.password ? 'is-invalid' : ''}`}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="view-pass"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                    </span>
                  </div>
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </div>
                <div className="field-form field-submit">
                  <button type="submit" className="awe-btn awe-btn-13">LOGIN</button>
                </div>
                <div className="account-desc">
                  <Link to="/register">
                    <a href='javascript: void(0)'>I don't have an account, Register Now</a>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginComponent;